<template>
  <hr
    class="w-full shadow-none border-none rounded-none"
    :class="computedClass"
  />
</template>

<script>
export default {
  name: 'keyline',
  props: {
    color: {
      type: String,
      default: 'grey'
    }
  },
  computed: {
    computedClass() {
      return this.color === 'gradient'
        ? 'h-2px bg-gradient-r-red-orange'
        : 'h-1px bg-grey';
    }
  }
};
</script>
